import React, { useEffect } from "react";
import RadioInput from "../inputs/RadioInput";
import TextInput from "../inputs/TextInput";
import SortCodeInput from "../inputs/SortCodeInput";

const DirectDebit = ({ method, watch, errors, register, setValue, id }) => {
	const watchedSortCode = watch("direct_debit_sort_code") || [];

	// Watch the account holder value for debugging
	const handleSortCodeChange = (newValues) => {
		setValue("direct_debit_sort_code", newValues);
	};

	return (
		<div className="section-direct-debit field-section-wrapper">
			<h2>Account details</h2>
			<div className="field-wrapper">
				<RadioInput
					label="I hold a UK Bank / Building Society Account and am the account holder"
					required={true}
					options={[
						{ value: "1", label: "Yes" },
						{ value: "0", label: "No" },
					]}
					register={register}
					validate={(value) => {
						if (value === "0") {
							return "You must be the account holder";
						}
						return true;
					}}
					id={`${id}_direct_debit_accountholder`}
					error={errors?.[`${id}_direct_debit_accountholder`]}
				/>
			</div>
			<div className="field-wrapper">
				<RadioInput
					label="I confirm that I am the only person required to authorise debits from this account"
					required={true}
					options={[
						{ value: "1", label: "Yes" },
						{ value: "0", label: "No" },
					]}
					register={register}
					validate={(value) => {
						if (value === "0") {
							return "You must confirm that you are the only person required to authorise debits from this account";
						}
						return true;
					}}
					id={`${id}_direct_debit_authorise`}
					error={errors?.[`${id}_direct_debit_authorise`]}
				/>
			</div>
			<div className="field-wrapper">
				<TextInput
					label="Account Holder Name:"
					{...register(`${id}_direct_debit_account_name`, {
						required: "Account holder name is required",
						pattern: {
							value: /^[A-Za-z\-'& ]+$/,
							message:
								"Name can only contain letters, spaces, hyphens, ampersands and apostrophes",
						},
					})}
					required={true}
					error={errors?.[`${id}_direct_debit_account_name`]}
				/>
			</div>
			<div className="field-wrapper">
				<SortCodeInput
					label="Sort Code:"
					value={watchedSortCode}
					onChange={handleSortCodeChange}
					required={true}
					error={errors?.[`${id}_direct_debit_sort_code`]}
				/>
			</div>
			<div className="field-wrapper">
				<TextInput
					label="Account Number:"
					name="direct_debit_account_number"
					{...register(`${id}_direct_debit_account_number`, {
						required: "Account number is required",
						pattern: {
							value: /^\d{8}$/,
							message: "Account number must be exactly 8 digits",
						},
					})}
					required={true}
					error={errors?.[`${id}_direct_debit_account_number`]}
					descriptionBelow="The 8-digit number usually found on the front of your debit card"
				/>
			</div>
			<div className="field-wrapper">
				<RadioInput
					label="Please take monthly payment from my account on:"
					required={true}
					options={[
						{ value: "1", label: "1st" },
						{ value: "15", label: "15th" },
						{ value: "25", label: "25th" },
					]}
					register={register}
					id={`${id}_direct_debit_payment_date`}
					error={errors?.[`${id}_direct_debit_payment_date`]}
				/>
			</div>
		</div>
	);
};

export default DirectDebit;
